const toPositiveNumber = (value) => {
  const number = Number(value)
  return Number.isFinite(number) && number > 0 ? number : null
}

export const getDefaultOrderQuantity = (settings = {}) => {
  const minimum = toPositiveNumber(settings.minimumSalesOrderQuantity)
  const multiple = toPositiveNumber(settings.salesQuantityMultiple)

  if (minimum !== null && multiple !== null) {
    return Math.ceil((minimum - 1e-9) / multiple) * multiple
  }

  return minimum || multiple || 1
}

export const validateOrderQuantity = (quantity, settings = {}) => {
  const value = Number(quantity)
  const minimum = toPositiveNumber(settings.minimumSalesOrderQuantity)
  const multiple = toPositiveNumber(settings.salesQuantityMultiple)

  if (!Number.isFinite(value) || value <= 0) {
    return { isValid: false, reason: 'invalid', minimum, multiple }
  }

  if (minimum !== null && value < minimum) {
    return { isValid: false, reason: 'belowMinimum', minimum, multiple }
  }

  if (multiple !== null) {
    const quotient = value / multiple
    if (Math.abs(quotient - Math.round(quotient)) > 1e-9) {
      return { isValid: false, reason: 'notMultiple', minimum, multiple }
    }
  }

  return { isValid: true, reason: null, minimum, multiple }
}

export const getOrderQuantityErrorKey = (validation) => {
  if (validation.reason === 'belowMinimum') return 'quotation:lines.quantityBelowMinimum'
  if (validation.reason === 'notMultiple') return 'quotation:lines.quantityNotMultiple'
  if (validation.reason === 'invalid') return 'quotation:lines.quantityInvalid'
  return null
}